export default {
  en: {
    app:{
      verify: {
        text: 'Email not verified',
        button: 'Resend verification email',
      }
    }
  },
  de: {
    app:{
      verify: {
        text: 'Email nicht verifiziert',
        button: 'Verifizierungs-E-Mail erneut senden',
      }
    }
  },
  es: {
    app:{
      verify: {
        text: 'Correo electrónico no verificado',
        button: 'Reenviar correo de verificación',
      }
    }
  },
  uk: {
    app:{
      verify: {
        text: 'Електронна пошта не підтверджена',
        button: 'Відправити лист підтвердження ще раз',
      }
    }
  }
}
